var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQrLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11H3V3H11V11ZM9 5H5V9H9V5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21H3V13H11V21ZM9 15H5V19H9V15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11V3H21V11H13ZM15 9H19V5H15V9Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 2,
    height: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 2,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 2,
    height: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 17,
    width: 2,
    height: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 19,
    width: 2,
    height: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 2,
    height: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 13,
    width: 2,
    height: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 15,
    width: 2,
    height: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrLine);
export default __webpack_public_path__ + "static/media/QRLine.066c460a.svg";
export { ForwardRef as ReactComponent };